import React from "react";
import { Crown, Star } from "lucide-react";

const FALLBACK_IMAGES = [
  "https://images.pexels.com/photos/16116150/pexels-photo-16116150.jpeg",
  "https://images.pexels.com/photos/33354945/pexels-photo-33354945.jpeg",
  "https://images.pexels.com/photos/12438467/pexels-photo-12438467.jpeg",
  "https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=1200",
  "https://images.unsplash.com/photo-1571896349842-33c89424de2d?w=1200",
  "https://images.unsplash.com/photo-1502602898657-3e91760cbb34?w=1200",
];

export default function PremiumDMCCard({ dmc, idx = 0 }) {
  const img = FALLBACK_IMAGES[idx % FALLBACK_IMAGES.length];
  return (
    <article
      className="relative h-[360px] rounded-xl overflow-hidden border border-[#262626] group cursor-pointer"
      data-testid={`premium-dmc-${dmc.user_id}`}
    >
      <img
        src={img}
        alt={dmc.name}
        className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-black/95 via-black/50 to-transparent" />
      {dmc.premium && (
        <span className="absolute top-4 left-4 inline-flex items-center gap-1 bg-brand text-white text-xs font-bold uppercase tracking-widest px-2.5 py-1 rounded-sm">
          <Crown className="w-3 h-3" /> Premium
        </span>
      )}
      <div className="absolute inset-x-0 bottom-0 p-6">
        <p className="overline">{dmc.country || "Global"}</p>
        <h3 className="font-display text-2xl font-bold text-white mt-2 leading-tight">{dmc.name}</h3>
        <div className="flex items-center gap-3 mt-3 text-sm text-[#a3a3a3]">
          <span className="inline-flex items-center gap-1">
            <Star className="w-3.5 h-3.5 fill-brand stroke-brand" />
            <span className="font-mono text-white">{dmc.rating?.toFixed?.(1) || "4.7"}</span>
          </span>
          <span className="text-[#404040]">·</span>
          <span className="font-mono">{dmc.win_count || 0} wins</span>
          <span className="text-[#404040]">·</span>
          <span className="font-mono">{dmc.bid_count || 0} bids</span>
        </div>
        {dmc.specialties?.length > 0 && (
          <div className="flex flex-wrap gap-1.5 mt-3">
            {dmc.specialties.slice(0, 3).map((s) => (
              <span key={s} className="text-[10px] font-mono uppercase tracking-wider text-white border border-white/30 px-2 py-0.5">
                {s}
              </span>
            ))}
          </div>
        )}
      </div>
    </article>
  );
}
